<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="d-flex justify-content-center align-items-center vh-100">
          <div class="user-cta">
            <Icon name="grCheckCircle" width="36" class="mb-3"/>
            <div class="mb-5">
              <h4 class="user-cta__title">{{ $t('fotosmile.unlocked_title') }}</h4>
              <h5 class="user-cta__subtitle">{{ $t('fotosmile.unlocked_subtitle') }}</h5>
            </div>
            <b-button class="user-cta__action" variant="primary" @click="goToGallery">
              {{ $t('fotosmile.unlocked_cta') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'FotosmileUnlocked',
  computed: {
    picacode() {
      const result = this.$route.params.result
      return result ? result.picacode : null
    },
  },
  methods: {
    goToGallery() {
      if (this.picacode) {
        this.$router.push({name: 'checkins-detail', params: {picacode: this.picacode}})
      } else {
        this.$router.push({name: 'checkins-list'})
      }
    },
  },
}
</script>
<style>
.site-banner {
  display: none !important;
}
</style>
